import { render, staticRenderFns } from "./ModalWidgetShare.vue?vue&type=template&id=fee548f0&scoped=true&lang=pug"
import script from "./ModalWidgetShare.vue?vue&type=script&lang=js"
export * from "./ModalWidgetShare.vue?vue&type=script&lang=js"
import style0 from "./ModalWidgetShare.vue?vue&type=style&index=0&id=fee548f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee548f0",
  null
  
)

export default component.exports